module.exports = __webpack_public_path__ + "img/emoji_97.d61117c7.png";